import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import SuperstarAuctionNav from "../../SupestarAuctionNav/SuperstarAuctionNav";

import ProductCardStar from "../../ProductCardStar";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";

const SoldProductList = () => {
  const [soldProduct, setSoldProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/star/sold/auction/product/all`).then((res) => {
      if (res.status === 200) {
        setSoldProduct(res.data.products);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <SuperstarAuctionNav />
      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>
        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">Live Now</div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCardStar data={soldProduct} noBidder="true" />
      )}
    </>
  );
};

export default SoldProductList;
